// Schema for Create User form
// Mirrors the current fields in `components/forms/CreateUserForm.js`

export const CREATE_USER_SCHEMA = {
  User_Info: [
    {
      section: "User Information",
      fields: [
        {
          name: "firstname",
          label: "First Name",
          type: "input",
          required: true,
          input_type: "text",
          icon: "/images/icons/user_light_blue.svg",
          placeholder: "First Name",
          hideLabel: true,
        },
        {
          name: "email",
          label: "Email",
          type: "input",
          required: true,
          input_type: "email",
          icon: "/images/icons/email_blue_light.svg",
          placeholder: "Email",
          hideLabel: true,
        },
        {
          name: "password",
          label: "Password",
          type: "input",
          required: true,
          input_type: "password",
          placeholder: "Password",
          hideLabel: true,
        },
      ],
    },
  ],
};

export default CREATE_USER_SCHEMA;
